import config from "./Config";
import { UpdateProfileRequest } from '../classes/UpdateProfileRequest';


export const realizarCheckIn = async (reservationId, checkInRequest) => {
  const baseUrl = config.baseUrl;
  const token = localStorage.getItem("authToken");

  const url = `${baseUrl}/OHIPReservations/RealizarCheckIn/${reservationId}`;

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(checkInRequest),
    });

    if (response.ok) {
      console.log("Check-in realizado correctamente.");
      return true;
    } else {
        const errorText = await response.text(); 
        const customError = new Error("Error en la solicitud");
        customError.detail = errorText;
        customError.status = response.status;
        throw customError;
    }
  } catch (error) {
    console.error("Error al realizar el check-in:", error);
    throw error; // Propaga error para que lo capture handleCheckIn
  }
};
 


export const asignarNumeroHabitacion = async (reservationId, roomAssignmentRequest) => {
    const baseUrl = config.baseUrl;
    const token = localStorage.getItem("authToken");
  
    const url = `${baseUrl}/OHIPReservations/AsignarNumeroHabitacion/${reservationId}`;
  
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(roomAssignmentRequest),
      });
  
      if (!response.ok) {
        throw new Error(`Error en la solicitud: ${response.status}`);
      }
  
      // El endpoint devuelve un booleano: true o false
      const result = await response.json();
      return result; // ← true o false
    } catch (error) {
      console.error("Error al asignar número de habitación:", error);
      throw error;
    }
  };  


export const getReservaPorConfirmationId = async (confirmationId) => {
    const baseUrl = config.baseUrl; //"https://vmi2198182/api";
    const token = localStorage.getItem("authToken");
    const unidadNegocio = localStorage.getItem("businessUnit");

    const url = `${baseUrl}/OHIPReservations/GetReservationByConfirmation?hotelId=${unidadNegocio}&confirmationNumber=${confirmationId}`;

    console.log("confirmation Id", confirmationId);
    console.log("Base URL:", baseUrl);
    console.log("Token:", token);
    console.log("Unidad de Negocio:", unidadNegocio);
    console.log("URL:", url);


    try {
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json",
                "Unidad-Negocio": unidadNegocio // Si se requiere este encabezado
            },
        });

        if (!response.ok) {
            const errorText = await response.text(); // Lee la respuesta en texto para ver el error detallado.
            console.error("Error en respuesta del servidor:", errorText);
            throw new Error(`Error en la solicitud: ${response.status} - ${errorText}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error al realizar la solicitud:", error);
        throw error;
    }
};

export const agregarUsuario = async (usuario) => {
    const baseUrl = config.authBaseUrl;
    const token = localStorage.getItem("authToken");
    const url = `${baseUrl}/Cuentas/RegistrarUsuarioConRoles`;

    try {
        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(usuario)
        });

        if (!response.ok) {
            throw new Error(`Error en la solicitud: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error al agregar usuario:", error);
        throw error;
    }
};

export const obtenerUsuarios = async () => {
    const baseUrl = config.authBaseUrl;
    const token = localStorage.getItem("authToken");
    const url = `${baseUrl}/Cuentas/ObtenerUsuarios`;

    try {
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });

        if (!response.ok) {
            throw new Error(`Error en la solicitud: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error al obtener usuarios:", error);
        throw error;
    }
};

export const obtenerUsuarioPorEmail = async (email) => {
    const baseUrl = config.baseUrl; //"https://vmi2198182/api";
    const token = localStorage.getItem("authToken");

    const url = `${baseUrl}/Cuentas/ObtenerUsuarioPorEmail?email=${encodeURIComponent(email)}`;

    try {
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });

        if (!response.ok) {
            throw new Error(`Error en la solicitud: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error al realizar la solicitud:", error);
        throw error;
    }
};

export const getBuscarReservas = async ({ givenName, surname, arrivalStartDate, departureStartDate, roomType, offset = 0, limit = 20 }) => {

    console.log('REACT_APP_AUTH_BASE_URL =', process.env.REACT_APP_AUTH_BASE_URL);
    console.log('REACT_APP_API_BASE_URL_PBCH =', process.env.REACT_APP_API_BASE_URL_PBCH);
    console.log('REACT_APP_API_BASE_URL_PEBEBRO =', process.env.REACT_APP_API_BASE_URL_PEBEBRO);

    console.log('baseURL = ', config.baseUrl);
    const baseUrl = config.baseUrl;
    const baseUrll = `${baseUrl}/OHIPReservations/BuscarReservas`;
    const token = localStorage.getItem("authToken");
  
    const queryParams = new URLSearchParams();
    
    if (givenName) queryParams.append('givenName', givenName);
    if (surname) queryParams.append('surname', surname);
    if (arrivalStartDate) queryParams.append('arrivalStartDate', arrivalStartDate);
    if (arrivalStartDate) queryParams.append('arrivalEndDate', arrivalStartDate);
    if (departureStartDate) queryParams.append('departureStartDate', departureStartDate);
    if (roomType) queryParams.append('roomType', roomType);

    queryParams.append('offset', offset);
    queryParams.append('limit', limit);
  
    const urlWithParams = `${baseUrll}?${queryParams.toString()}`;
  
    try {
      const response = await fetch(urlWithParams, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
  
      if (!response.ok) {
        throw new Error(`Error en la solicitud: ${response.status}`);
      }
  
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error al realizar la solicitud:', error);
      throw error;
    }
  };
  

  export const actualizarPerfilHuesped = async (formData, profileId) => {
    const baseUrl = config.baseUrl; //"https://vmi2198182/api";
    const token = localStorage.getItem("authToken");
    const url = `${baseUrl}/OHIPCustomers/UpdateProfile/${profileId}`;

    console.log(url);

    try {
        // Crear instancia de la clase con los datos proporcionados
        console.log(formData);
        
        //const clienteDto = new MainProfileDetails(formData, profileId);
        const clienteDto = new UpdateProfileRequest(formData, profileId);

        console.log("clienteDto", JSON.stringify(clienteDto));

        const response = await fetch(url, {
            method: "PUT",
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(clienteDto),
        });

        if (!response.ok) {
            throw new Error(`Error en la solicitud: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error al realizar la solicitud:", error);
        throw error;
    }
};

export const CreateProfile = async (profileDetails) => {
    const baseUrl = config.baseUrl; //"https://vmi2198182/api";
    const token = localStorage.getItem("authToken");
    const url = `${baseUrl}/OHIPCustomers/CreateProfile`;

    try {
        // Log de la solicitud
        console.log("Enviando a CreateProfile:", JSON.stringify(profileDetails, null, 2));

        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(profileDetails),
        });

        // Validar si la respuesta es exitosa
        if (!response.ok) {
            throw new Error(`Error en la solicitud: ${response.status} - ${response.statusText}`);
        }

        // Parsear la respuesta
        const data = await response.json();
        console.log("Respuesta de CreateProfile:", data);

        // Validar la existencia de `profileId` en la respuesta
        if (!data) {
            throw new Error("La respuesta no contiene un profileId válido");
        }

        return data;
    } catch (error) {
        console.error("Error en CreateProfile:", error);
        throw error;
    }
};


export const UpdateReservation = async (hotelId, reservationId, reservationDetails) => {
    const baseUrl = config.baseUrl;
    const token = localStorage.getItem("authToken");
    const url = `${baseUrl}/OHIPCustomers/ActualizarReserva/${localStorage.getItem("businessUnit")}/${reservationId}`;

    try {
        const response = await fetch(url, {
            method: "PUT",
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(reservationDetails),
        });

        if (!response.ok) {
          let errorMessage = `Error en la solicitud: ${response.status}`;
          try {
              const contentType = response.headers.get("Content-Type");
              if (contentType && contentType.includes("application/json")) {
                  const errorBody = await response.json();
                  errorMessage = errorBody.error || errorBody.message || errorMessage;
              } else {
                  const errorText = await response.text();
                  errorMessage = errorText || errorMessage;
              }
          } catch (parseError) {
              console.warn("Error al intentar leer el cuerpo del error:", parseError);
          }

          throw new Error(errorMessage);
      }

      const data = await response.json();
      return data;

    } catch (error) {
        console.error("Error al actualizar la reserva:", error);
        throw error;
    }
};

export const buscarHabitacionesDisponibles = async (searchParams) => {
    const baseUrl = config.baseUrl;
    const token = localStorage.getItem("authToken");

    const url = `${baseUrl}/OHIPReservations/BuscarHabitacionesDisponibles`;

    try {
        const response = await fetch(url, {
            method: "POST", 
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(searchParams) // Envío del body como JSON
        });

        if (!response.ok) {
            throw new Error(`Error en la solicitud: ${response.status}`);
        }

        const data = await response.json();

        // Mapear solo lo necesario para el frontend
        return data.map(item => ({
            room: {
                roomId: item.roomId,
            },
            roomCategory: item.roomCategory,
            status: item.status
        }));
    } catch (error) {
        console.error("Error al buscar habitaciones:", error);
        throw error;
    }
};


export const buscarHabitacionesOHIP = async (params) => {
    const baseUrl = config.baseUrl;
    const token = localStorage.getItem("authToken");
    const url = `${baseUrl}/OHIPReservations/BuscarHabitacionesDisponibles`;

    const queryParams = new URLSearchParams();

    if (params.HotelCode) queryParams.append('HotelCode', params.HotelCode);
    if (params.ReservationId) queryParams.append('ReservationId', params.ReservationId);
    if (params.PerfectFitRoomsOnly !== undefined) queryParams.append('PerfectFitRoomsOnly', params.PerfectFitRoomsOnly);
    
    if (params.HotelRoomStatus && params.HotelRoomStatus.length > 0)
        params.HotelRoomStatus.forEach(status => queryParams.append('HotelRoomStatus', status));

    if (params.HotelFORoomStatus && params.HotelFORoomStatus.length > 0)
        params.HotelFORoomStatus.forEach(status => queryParams.append('HotelFORoomStatus', status));

    try {
        const response = await fetch(`${url}?${queryParams.toString()}`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });

        if (!response.ok) {
            throw new Error(`Error en la solicitud: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error al obtener habitaciones:", error);
        throw error;
    }
};

export const createAlert = async (hotelId, reservationId, description) => {
    const baseUrl = config.baseUrl;
    const token = localStorage.getItem("authToken");

    const url = `${baseUrl}/OHIPReservations/CreateAlert`;

    const payload = {
        hotelId,
        reservationId,
        description
    };

    try {
        const response = await fetch(url, {
            method: "PUT",
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(payload)
        });

        if (!response.ok) {
            throw new Error(`Error al crear alerta: ${response.status}`);
        }

        const result = await response.json();
        return result;
    } catch (error) {
        console.error("Error al crear alerta:", error);
        throw error;
    }
};

export const removerHabitacionAsignada = async (hotelId, reservationId) => {
  const baseUrl = config.baseUrl;
  const token = localStorage.getItem("authToken");

  const url = `${baseUrl}/OHIPReservations/RemoveRoomAssigned?hotelId=${encodeURIComponent(hotelId)}&reservationId=${encodeURIComponent(reservationId)}`;

  try {
    const response = await fetch(url, {
      method: "PUT",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json"
      }
    });

    if (!response.ok) {
      const errorText = await response.text(); // Captura el mensaje plano si hay error
      throw new Error(`Error al desasignar habitación: ${errorText || response.status}`);
    }

    // Como la API retorna Ok(true), simplemente parseamos el JSON como booleano
    const result = await response.json();
    if (result !== true) {
      throw new Error("La respuesta no fue exitosa.");
    }

    return true;
  } catch (error) {
    console.error("Error al desasignar habitación:", error);
    throw error;
  }
};



export const editarUsuario = async (usuario) => {
    const baseUrl = config.baseUrl;
    const token = localStorage.getItem("authToken");
    const url = `${baseUrl}/Cuentas/ActualizarUsuario`;

    try {
        const response = await fetch(url, {
            method: "PUT",
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(usuario),
        });

        if (!response.ok) {
            throw new Error(`Error al editar usuario: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error("Error al editar usuario:", error);
        throw error;
    }
};


export const eliminarUsuario = async (userName) => {
  const baseUrl = config.authBaseUrl;
  const token = localStorage.getItem("authToken");

  const url = `${baseUrl}/Cuentas/EliminarUsuario?userName=${encodeURIComponent(userName)}`;

  const response = await fetch(url, {
    method: "DELETE",
    headers: {
      "Authorization": `Bearer ${token}`,
    },
  });

  if (!response.ok) throw new Error("Error al eliminar usuario");
};

export async function removerRol(userName, roleName) {
    const baseUrl = config.baseUrl;
    const token = localStorage.getItem("authToken");
    
    const response = await fetch(`${baseUrl}/Cuentas/RemoverRole`, {
        method: "POST",
        headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ userName, roleName })
    });

    if (!response.ok) {
        throw new Error("Error al remover el rol");
    }
}

export async function asignarRoles(userName, roleNames) {
  const baseUrl = config.baseUrl;
  const token = localStorage.getItem("authToken");

  const response = await fetch(`${baseUrl}/Cuentas/AsignarRoles`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({ userName, roleNames }) 
  });

  if (!response.ok) {
    throw new Error("Error al asignar los roles");
  }
}

export async function obtenerRolesDeUsuario(userName) {
    const baseUrl = config.authBaseUrl;
    const token = localStorage.getItem("authToken");

    const response = await fetch(`${baseUrl}/Cuentas/ObtenerRolesDeUsuario?userName=${encodeURIComponent(userName)}`, {
        method: 'GET',
        headers: {
        'Authorization': `Bearer ${token}`
        }
    });

    if (!response.ok) {
        throw new Error("No se pudo obtener los roles del usuario");
    }

    return await response.json(); // ← debe ser una lista de strings
}

export async function actualizarRoles(userName, rolesAAgregar, rolesAEliminar) {
  const baseUrl = config.authBaseUrl;
  const token = localStorage.getItem("authToken");

  const response = await fetch(`${baseUrl}/Cuentas/ActualizarRoles`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({
      userName,
      rolesAAgregar,
      rolesAEliminar
    })
  });

  if (!response.ok) {
    throw new Error("Error al actualizar los roles");
  }
}

export const cambiarPassword = async ({ userName, oldPassword, newPassword }) => {
  const baseUrl = config.authBaseUrl;
  const token = localStorage.getItem("authToken");
  const url = `${baseUrl}/Cuentas/CambiarPassword`;

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ userName, oldPassword, newPassword })
  });

  if (!response.ok) {
    throw new Error("Error al cambiar la contraseña");
  }

  return await response.json();
};
